import { mapValues, trim } from 'lodash';

import text from './text.json';

const replace = (obj, locale) => mapValues(obj, v => {
  if (typeof Object.values(v)[0] === 'string') return v[locale];
  return replace(v, locale);
});

export const loadTexts = (path, locale = 'en') => {
  if (!path || typeof path !== 'string') return {};
  const nodes = path.split('.');
  const obj = nodes.reduce((acc, node) => (acc[node] || {}), text);
  if (!obj) return {};
  if (typeof Object.values(obj)[0] === 'string') return obj[locale];
  return replace(obj, locale);
};



// WEBPACK FOOTER //
// ./src/config/texts.js